import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const token = localStorage.getItem('AURÉNE_token');
    const savedUser = localStorage.getItem('AURÉNE_user');

    if (token && savedUser && savedUser !== "undefined") {

      try {

        setUser(JSON.parse(savedUser));

        api.get('auth/me')
          .then(res => {
            setUser(res.data.user);
            localStorage.setItem('AURÉNE_user', JSON.stringify(res.data.user));
          })
          .catch(() => logout());

      } catch {

        localStorage.removeItem('AURÉNE_user');
        localStorage.removeItem('AURÉNE_token');

      }

    }

    setLoading(false);

  }, []);

  const login = async (email, password) => {

    const res = await api.post('auth/login', { email, password });

    localStorage.setItem('AURÉNE_token', res.data.token);
    localStorage.setItem('AURÉNE_user', JSON.stringify(res.data.user));

    setUser(res.data.user);

    return res.data.user;
  };

  /* ⭐ REGISTER SHOULD NOT LOGIN */
  const register = async (data) => {

    const res = await api.post('auth/register', data);

    return res.data;

  };

  const logout = () => {

    localStorage.removeItem('AURÉNE_token');
    localStorage.removeItem('AURÉNE_user');

    setUser(null);

  };

  const value = useMemo(() => ({
    user,
    loading,
    login,
    register,
    logout,
    setUser,
    isMainAdmin: user?.role === 'main_admin',
    isLocalAdmin: user?.role === 'local_admin',
    isSeller: ['seller', 'local_admin', 'main_admin'].includes(user?.role),
    isBuyer: user?.role === 'buyer'
  }), [user, loading]);

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );

};

export const useAuth = () => useContext(AuthContext);